import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import show from "../../api/public/storePages/show";
import { Stack, Typography } from "@mui/material";
import StorePage from "../../components/displays/storePages/StorePage";
import useCheckoutStore from "../../stores/public/useCheckoutStore";

export default function PublicStorePage() {
  const [ storePageError, setStorePageError ] = useState(null);

  const { reset, storePage, setStorePage } = useCheckoutStore();

  const { id } = useParams();
  
  useEffect(() => {
    reset();
    show(id, (response) => {
      console.log(response);
      setStorePage(response);
    }, () => {
      setStorePageError(true);
    });
  }, []);

  if(storePageError || !storePage) {
    return <Stack textAlign="center">
      <Typography variant="h4">
        Store Page Not Found
      </Typography>
    </Stack>;
  }

  return (
    <Stack minHeight="100vh" bgcolor={storePage.background_color}>
      <StorePage storePage={storePage} />
    </Stack>
  );
}